import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ConfirmationDialogData } from '@app/shared/models/confirmation-modal';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'am-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
  standalone: true,
})
export class ConfirmationModalComponent {
  dialogRef = inject<MatDialogRef<ConfirmationModalComponent>>(MatDialogRef);
  data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);

  onClick(confirm: boolean): void {
    this.dialogRef.close(confirm);
  }
}
